module.exports = __webpack_public_path__ + "static/media/emj12.191159df.svg";